export default {"src":"/_next/static/media/Edit.efecd610.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};